import { render, staticRenderFns } from "./ResourcePreview.vue?vue&type=template&id=44e752bc&"
import script from "./ResourcePreview.vue?vue&type=script&lang=js&"
export * from "./ResourcePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports